import { retryApprovalPreReview, type Approval } from '../../api/hub/collaboration'
import { MutationState, useHubMutation } from '../focus/shared'

export function ApprovalPreReviewRecovery({ approval, actor }: { approval: Approval; actor?: { id: string; role?: string; isAI?: boolean } }) {
  const retry = useHubMutation(() => retryApprovalPreReview(approval.id))
  const state = approval.preReviewRetry
  if (!state || approval.preReviewDisposition || approval.status.toUpperCase() !== 'PENDING') return null
  const canRetry = actor && !actor.isAI && (actor.id === approval.initiatorId || actor.role === 'CEO') && state.status === 'paused'
  return <section aria-label="AI 预审自动尝试状态">
    <p>AI 预审已尝试 {state.attempts} 次 · {state.status === 'paused' ? '自动尝试已暂停' : state.nextRetryAt ? `下次自动尝试：${new Date(state.nextRetryAt).toLocaleString('zh-CN')}` : '等待自动尝试'}</p>
    <p>{state.error}</p>
    <p>官方审批仍继续同步。此入口只恢复模型预审，不批准审批；外部发送结果未知时须先核验，不能盲重发。</p>
    {canRetry ? <button disabled={retry.isPending} onClick={() => retry.mutate()}>重试 AI 预审</button> : state.status === 'paused' && <p>等待发起人或 CEO 恢复模型预审。</p>}
    <MutationState mutation={retry}/>
  </section>
}
